/* import __COLOCATED_TEMPLATE__ from './ip-address-modal.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'embercom/services/intl';
import { inject as service } from '@ember/service';
import IpAllowListValidator from 'embercom/lib/ip-allowlist-validator';

interface Arguments {
  onClose: () => void;
  showModal: boolean;
  ipAddresses: string[] | undefined;
  onIpAddressAdded: (ipAddress: string) => void;
}

export default class IpAddressModal extends Component<Arguments> {
  @service declare intl: IntlService;
  @tracked newIpAddress = '';
  @tracked ipAddressIsValid = false;

  @action
  handleModalClose() {
    this.args.onClose();
    this.resetAttributes();
  }

  @action
  saveIpAddress() {
    this.args.onIpAddressAdded(this.newIpAddress);
    this.handleModalClose();
  }

  @action
  cancelAddIpAddress() {
    this.handleModalClose();
  }

  @action
  resetAttributes() {
    this.newIpAddress = '';
    this.ipAddressIsValid = false;
  }

  @action
  validateIpAddress() {
    let ipValidator = new IpAllowListValidator(this.newIpAddress, this.intl);
    this.ipAddressIsValid = ipValidator.isValid;
  }

  @action
  getIpAddressErrorMessage() {
    return this.intl.t('ai-agent.voice-playground.ip-address-modal.error-message');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Deploy::Voice::IpAddressModal': typeof IpAddressModal;
  }
}
